/* RevRunners calm homepage: presentation and accessible disclosure only.
 * Existing generation anchors, EasySearch controls, cart actions and prices
 * are never replaced. Without JavaScript the original links stay visible.
 */
(function () {
  'use strict';
  if (window.__rrHomeCalm) { window.__rrHomeCalm.scan(); return; }
  const cards = new Map();
  let sequence = 0;
  function configuration() {
    try { return JSON.parse(document.querySelector('[data-rr-home-calm-config]')?.textContent || '{}'); }
    catch (_) { return {}; }
  }
  function expand(state, open) {
    state.options.hidden = !open;
    state.button.setAttribute('aria-expanded', String(open));
    state.button.firstElementChild.textContent = open ? 'Hide generations' : 'Choose generation';
    state.button.setAttribute('aria-label', (open ? 'Hide generations for ' : 'Choose generation for ') + state.name);
    state.card.toggleAttribute('data-rr-calm-open', open);
  }
  function restore(state) {
    state.options.hidden = state.wasHidden;
    state.options.removeAttribute('data-rr-calm-options');
    if (state.generatedId) state.options.removeAttribute('id');
    state.more.forEach(([details, open]) => { details.open = open; });
    state.card.removeAttribute('data-rr-calm-card');
    state.card.removeAttribute('data-rr-calm-open');
    state.button.remove();
    state.controller.abort();
  }
  function revealHash() {
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
    if (!id) return;
    const target = document.getElementById(id);
    if (!target) return;
    const card = target.closest('.rrv__card');
    const state = cards.get(card);
    if (state && (target === state.options || state.options.contains(target))) expand(state, true);
  }
  function enhance(card) {
    if (cards.has(card)) return;
    const options = card.querySelector('.rrv__options');
    if (!options || !options.querySelector('a[data-rr-generation-link]')) return;
    const controller = new AbortController();
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'rrhc-generation-toggle';
    const label = document.createElement('span');
    const arrow = document.createElement('span');
    arrow.className = 'rrhc-generation-toggle__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    button.append(label, arrow);
    const state = {card, options, button, controller,
      name:card.querySelector('h3')?.textContent.trim() || 'this vehicle',
      wasHidden:options.hidden, generatedId:!options.id,
      more:[...options.querySelectorAll('details.rrv__more')].map(details => [details, details.open])};
    if (!options.id) options.id = 'rrhc-generation-options-' + (++sequence);
    button.setAttribute('aria-controls', options.id);
    options.before(button);
    options.setAttribute('data-rr-calm-options', '');
    card.setAttribute('data-rr-calm-card', '');
    // A single disclosure reveals every generation, rather than nesting a
    // second "More versions" step. Original details state is restored on opt-out.
    state.more.forEach(([details]) => { details.open = true; });
    button.addEventListener('click', () => expand(state, options.hidden), {signal:controller.signal});
    card.addEventListener('click', event => {
      const link = event.target instanceof Element ? event.target.closest('a.rrv__media,a.rrv__title-link') : null;
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      // Retain native hash navigation and focus; expose its target first.
      try { if (new URL(link.href, location.href).hash === '#' + options.id) expand(state, true); } catch (_) {}
    }, {signal:controller.signal});
    cards.set(card, state);
    expand(state, false);
  }
  function scan() {
    const cfg = configuration();
    const enabled = cfg.enabled === true;
    document.documentElement.classList.toggle('rr-home-calm', enabled);
    cards.forEach((state, card) => {
      if (!enabled || cfg.compact_cards !== true || !card.isConnected) { restore(state); cards.delete(card); }
    });
    if (enabled && cfg.compact_cards === true) {
      document.querySelectorAll('#rr-popular-vehicles .rrv__card').forEach(enhance);
      revealHash();
    }
  }
  window.__rrHomeCalm = {scan};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true}); else scan();
  window.addEventListener('hashchange', revealHash);
  window.addEventListener('pageshow', scan);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(scan));
  document.addEventListener('shopify:block:select', event => {
    const card = event.target instanceof Element ? event.target.closest('.rrv__card') : null;
    const state = cards.get(card);
    if (state) expand(state, true);
  });
})();
